import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function fetchManebDashboard(schoolId) {
    const { data } = await axios.get(buildApiUrl(`/Maneb/${schoolId}`));
    return data;
}

export async function createManebSession(payload) {
    const { data } = await axios.post(buildApiUrl("/Maneb/session"), payload);
    return data;
}

export async function syncManebCandidates(sessionId, classId) {
    const { data } = await axios.post(buildApiUrl(`/Maneb/session/${sessionId}/sync-candidates`), {
        classId,
    });
    return data;
}

export async function fetchSessionCandidates(sessionId) {
    const { data } = await axios.get(buildApiUrl(`/Maneb/session/${sessionId}/candidates`));
    return data;
}

export async function updateManebCandidate(candidateId, payload) {
    const { data } = await axios.put(buildApiUrl(`/Maneb/candidate/${candidateId}`), payload);
    return data;
}

export async function downloadCandidateRegister(sessionId) {
    const response = await axios.get(buildApiUrl(`/Maneb/session/${sessionId}/candidates/export`), {
        responseType: "blob",
    });
    const disposition = response.headers["content-disposition"] || "";
    const match = /filename="([^"]+)"/i.exec(disposition);
    const filename = match?.[1] || "MANEB-candidates.csv";
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export async function fetchMockResults(sessionId) {
    const { data } = await axios.get(buildApiUrl(`/Maneb/session/${sessionId}/mock-results`));
    return data;
}

export async function saveMockResults(payload) {
    const { data } = await axios.post(buildApiUrl("/Maneb/mock-results"), payload);
    return data;
}

export async function fetchCertificates(schoolId, examType) {
    const params = examType ? { examType } : {};
    const { data } = await axios.get(buildApiUrl(`/Maneb/${schoolId}/certificates`), { params });
    return data;
}

export async function upsertCertificate(payload) {
    const { data } = await axios.post(buildApiUrl("/Maneb/certificate"), payload);
    return data;
}

export async function processCertificatesFromMock(sessionId) {
    const { data } = await axios.post(buildApiUrl(`/Maneb/session/${sessionId}/process-certificates`));
    return data;
}
